export const WHATSAPP_NUMBER = "523324166849";

const CAMPAIGN_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
] as const;

function getWhatsAppContext(source?: string): string[] {
  if (typeof window === "undefined") {
    return source ? [`*Origen:* ${source}`] : [];
  }

  const currentUrl = new URL(window.location.href);
  const safePageUrl = `${currentUrl.origin}${currentUrl.pathname}`;
  const campaign = CAMPAIGN_PARAMS
    .map((key) => [key, currentUrl.searchParams.get(key)] as const)
    .filter((entry) => Boolean(entry[1]))
    .map(([key, value]) => `${key}=${value}`)
    .join(" | ");

  return [
    ...(source ? [`*Origen:* ${source}`] : []),
    `*Página:* ${safePageUrl}`,
    ...(campaign ? [`*Campaña:* ${campaign}`] : []),
  ];
}

export function buildWhatsAppUrl(message?: string, source?: string): string {
  const baseUrl = `https://wa.me/${WHATSAPP_NUMBER}`;
  if (!message) return baseUrl;

  const context = getWhatsAppContext(source);
  const completeMessage = context.length
    ? [message, "", ...context].join("\n")
    : message;

  return `${baseUrl}?text=${encodeURIComponent(completeMessage)}`;
}

export function openWhatsApp(message?: string, source?: string): Window | null {
  return window.open(buildWhatsAppUrl(message, source), "_blank", "noopener,noreferrer");
}
